export function detectGPUName(): string | "unknown" {
	const canv = document.createElement("canvas");

	if (!canv.setAttribute) {
		return "unknown";
	}

	canv.setAttribute("width", "1");
	canv.setAttribute("height", "1");
	document.body.appendChild(canv);

	const canvas = document.getElementsByTagName("canvas");
	const gl = canvas[0].getContext("webgl", { stencil: true });
	canvas[0].parentNode.removeChild(canvas[0]);

	if (!gl) {
		return "unknown";
	}

	const dbgRenderInfo = gl.getExtension("WEBGL_debug_renderer_info");
	let renderer;
	if (dbgRenderInfo != null) {
		renderer = gl.getParameter(dbgRenderInfo.UNMASKED_RENDERER_WEBGL);
		return renderer;
	} else {
		return "unknown";
	}
}

export function detectMaliGPU(renderer: string): boolean {
	return renderer.search("Mali-400") !== -1 || renderer.search("Mali-450") !== -1;
}